'use strict';

DoohApps.factory('LicenseHelper', ['$filter', '$q', 'DoohHelper', 'DialogHandler', 'PaymentHelper', 'ScheduleHelper','ScheduleValidationHelper', 'campaignBLL', 'User',
    function ($filter, $q, DoohHelper, DialogHandler, PaymentHelper, ScheduleHelper, ScheduleValidationHelper, CampaignBLL, User) {

        var licenseData = {
            licensesList: [],
            noLicenseDevices:[]
        };

        return {
            getLicenses: getLicenses,
            checkIfLicenseValid: checkIfLicenseValid,
            licenseData: licenseData,
            loadLicenseData: loadLicenseData,
            toggleLicenseAcquire: toggleLicenseAcquire,
            loadVouchers: loadVouchers
        }

        function getLicenses(chosenCampaign, chosenDevices, deviceFilter, isExistingSchedule, repeatData) {
            var deferred = $q.defer();
            if (chosenCampaign == null)
                deferred.resolve();
            else {
                var deviceIds = '';
                var groupIds = '';
                angular.forEach(chosenDevices, function (device) {
                    if (DoohHelper.isValidAndMatchID(device.MediaID)) deviceIds += `${device.MediaID} `;
                    if (DoohHelper.isValidAndMatchID(device.GroupID)) groupIds += `${device.GroupID} `;
                });

                if (deviceIds == '' && groupIds == '' && isExistingSchedule == true) {
                    if (deviceFilter.mediaID != null && deviceFilter.mediaID != 0) {
                        deviceIds = `${deviceFilter.mediaID}`;
                    } else if (deviceFilter.groupID != null && deviceFilter.groupID != 0) {
                        groupIds = `${deviceFilter.groupID}`;
                    }

                    if (deviceIds == '' && groupIds == '') {
                        ScheduleHelper.flags.isLoading = false;
                        DialogHandler.AddError('Error occured while loading licenses!');
                        return;
                    }
                }

                var filter = {};
                filter.ApplicationId = chosenCampaign.ApplicationID;
                filter.MediaIDs = deviceIds;
                filter.GroupIds = groupIds;

                filter.eventEnd = `${DoohHelper.dateToMoment(repeatData.EndDate).format(DoohHelper.dcFormat)} ${repeatData.EndTime}`;
                filter.eventStart = `${DoohHelper.dateToMoment(repeatData.StartDate).format(DoohHelper.dcFormat)} ${repeatData.StartTime}`;

                ScheduleHelper.flags.isLicenseLoading = true;
                CampaignBLL.getLicensesForDevices(function (data) {
                    deferred.resolve(data);
                }, filter);
            }
            
            return deferred.promise;
        }
        
        function checkIfLicenseValid(license, device, calendarEnd, calendarStart, removeLicenseIndexList, licenseIndex) {
            var partnerIndex = -1;
            var partnerCount = 0;
            if (license.Licenses != null && license.Licenses.length > 0) {
                device.LicensesPeriods = license.LicensesPeriods;
                var continueLoop = true;
                angular.forEach(license.LicensesPeriods, function (licensePeriod, licensePeriodIndex) {
                    if (licensePeriod[0].ExpiredDate == null) {
                        license.ScreenTitle = device.ScreenTitle;
                        device.hasLicense = true;
                        continueLoop = false;
                    }
                    if (continueLoop) {
                        var licenseExpireDate = licensePeriod[licensePeriod.length - 1].ExpiredDate;
                        var licenseStartDate = licensePeriod[0].StartDate;

                        var ExpiredDate = licenseExpireDate == null
                            ? null
                            : DoohHelper.stringToDate(licenseExpireDate);
                        licenseStartDate = DoohHelper.stringToDate(licenseStartDate);

                        if (ExpiredDate != null) {
                            if (((licenseStartDate <= calendarStart && licenseStartDate < ExpiredDate)
                                && (licenseStartDate < calendarEnd && calendarEnd <= ExpiredDate))) {
                                license.ScreenTitle = device.ScreenTitle;
                                device.hasLicense = true;
                                continueLoop = false;
                                if (licensePeriod[0].LicenseType != 0)
                                    partnerIndex = licensePeriodIndex;
                            }
                        }
                    }
                });
                if (!device.hasLicense)
                    removeLicenseIndexList.push(licenseIndex);
                else {
                    if (partnerIndex != -1 && partnerIndex != 0) {
                        var partnerPeriod = device.LicensesPeriods.splice(partnerIndex, 1);
                        device.LicensesPeriods.unshift(partnerPeriod[0]);
                        ScheduleHelper.flags.canAddLicense = true;
                        partnerCount++;
                    } else if (partnerIndex == 0) {
                        ScheduleHelper.flags.canAddLicense = true;
                        partnerCount++;
                    }
                }
            } else {
                device.LicensesPeriods = null;
                removeLicenseIndexList.push(licenseIndex);
            }
            return partnerCount;
        }

        function loadLicenseData(data, chosenDevices, chosenCampaign, repeatData, noLicenseDevices) {
            var deferred = $q.defer();
            ScheduleHelper.flags.isLoading = true;
            if (data.hasError) {
                DialogHandler.AddError('Could not load license information!');
                ScheduleHelper.flags.isLoading = false;
                deferred.resolve();
            } else {
                ScheduleHelper.flags.canAddLicense = false;//can add extra license if existing is partner
                licenseData.licensesList = [];

                // in C#7 tuple items can be named, but there are limitations so Item1,Item2 cannot be named 
                var licensesList = data.content.Item1;
                var groupLicensesList = data.content.Item2;//dictionary object

                processLicenses(licensesList, groupLicensesList, chosenDevices, chosenCampaign, repeatData, noLicenseDevices).then(function (resolveObj) {
                    licenseData.licensesList = resolveObj.licenses;
                    licenseData.noLicenseDevices = resolveObj.noLicenseDevices;
                    
                    ScheduleHelper.flags.isLoading = false;
                    deferred.resolve();
                });
            }
            return deferred.promise;
        }

        function processLicenses (licenseList, groupLicensesList, chosenDevices, chosenCampaign, repeatData, noLicenseDevices) {
            var deferred = $q.defer();
            var calendarStart = processCalendarStartForLicense(repeatData);
            var calendarEnd = processCalendarEndForLicense(repeatData);

            angular.forEach(chosenDevices, function (device) {
                if (DoohHelper.isValidAndMatchID(device.MediaID)) device.hasLicense = false;
                if (DoohHelper.isValidAndMatchID(device.GroupID)) {
                    device.hasLicense = false;
                    if (device.GroupMediaDevices && device.GroupMediaDevices.length > 0) {
                        angular.forEach(device.GroupMediaDevices, function (groupDevice) {
                            groupDevice.hasLicense = false;
                        });
                    }
                }
            });

            var processedlicenses = processDeviceLicenses(licenseList, calendarStart, calendarEnd, chosenDevices);
            var processedgroupLicenses = processGroupLicenses(groupLicensesList, calendarStart, calendarEnd, chosenDevices);
            processNoLicenseDevices(calendarStart, calendarEnd, chosenCampaign, chosenDevices, noLicenseDevices, repeatData)
                .then(function (noLicenseDevices) {
                    if (ScheduleHelper.flags.canAquireLicense)
                        loadVouchers(repeatData, ScheduleHelper.repeatPlaceHolders, chosenCampaign, noLicenseDevices, ScheduleHelper.flags.canAquireLicense);
                    var resolveObject = {
                        licenses: processedlicenses.concat(processedgroupLicenses),
                        noLicenseDevices: noLicenseDevices
                    }
                    deferred.resolve(resolveObject);
                });

            return deferred.promise;
        }

        function processDeviceLicenses(licenseList, calendarStart, calendarEnd, chosenDevices) {
            var removeLicenseIndexList = [];
            var partnerCount = 0;
            angular.forEach(licenseList, function (license, licenseIndex) {
                angular.forEach(chosenDevices, function (device) {
                    if (DoohHelper.isValidAndMatchID(device.MediaID, license.MediaID)) {
                        partnerCount += checkIfLicenseValid(license, device, calendarEnd, calendarStart, removeLicenseIndexList, licenseIndex);
                    }
                });
            });

            if (partnerCount == 0) {
                ScheduleHelper.flags.canAddLicense = false;
                ScheduleHelper.flags.canAquireLicense = false;
            }

            if (removeLicenseIndexList.length > 0) {
                removeLicenseIndexList.sort(function (a, b) { return b - a });
                for (var rlil = 0; rlil < removeLicenseIndexList.length; rlil++) {
                    licenseList.splice(removeLicenseIndexList[rlil], 1);
                }
            }
            
            return licenseList;
        }

        function processGroupLicenses(groupLicensesList, calendarStart, calendarEnd, chosenDevices) {
            var removeLicenseIndexList = [];
            var partnerCount = 0;
            var hasLicenseList = [];
            angular.forEach(groupLicensesList, function (licenseList, groupID) {
                if (groupID != '$id') {
                    var group = $filter('filter')(chosenDevices, { GroupID: Number(groupID) }, true);
                    if (group.length == 0) return;
                    group = group[0];

                    angular.forEach(licenseList, function (license, licenseIndex) {
                        angular.forEach(group.GroupMediaDevices, function (device) {
                            if (DoohHelper.isValidAndMatchID(device.MediaID, license.MediaID)) {
                                partnerCount += checkIfLicenseValid(license, device, calendarEnd, calendarStart, removeLicenseIndexList, licenseIndex);
                            }
                        });
                    });
                    if (partnerCount == 0) {
                        ScheduleHelper.flags.canAddLicense = false;
                        ScheduleHelper.flags.canAquireLicense = false;
                    }
                    if (removeLicenseIndexList.length > 0) {
                        removeLicenseIndexList.sort(function (a, b) { return b - a });
                        for (var removeLicenseIndex = 0; removeLicenseIndex < removeLicenseIndexList.length; removeLicenseIndex++) {
                            licenseList.splice(removeLicenseIndexList[removeLicenseIndex], 1);
                        }
                        removeLicenseIndexList = [];
                    }
                    if (licenseList.length > 0 && group.GroupMediaDevices.length == licenseList.length) {
                        hasLicenseList.push({ groupID: groupID, groupName: group.GroupName, licenseList: licenseList, showLimit: 1 });
                        group.hasLicense = true;
                    } else group.hasLicense = false;
                }
            });
                        
            return hasLicenseList;
        }

        function processNoLicenseDevices(calendarStart, calendarEnd, chosenCampaign, chosenDevices, noLicenseDevices, repeatData) {
            var deferred = $q.defer();
            var devicesWithNoLicense = angular.copy(noLicenseDevices);
            noLicenseDevices = [];
            PaymentHelper.setTotalSum(0);
            angular.forEach(chosenDevices, function (chosenDevice) {
                var oldListIndex = -1;
                chosenDevice.monthsDiff = 1;
                angular.forEach(devicesWithNoLicense, function (noLicenseDevice, key) {
                    if ((DoohHelper.isValidAndMatchID(chosenDevice.MediaID, noLicenseDevice.MediaID))
                        || (DoohHelper.isValidAndMatchID(chosenDevice.GroupID, noLicenseDevice.GroupID)))
                        oldListIndex = key;
                });

                var devHasPartnerLicense = false;

                if (DoohHelper.isValidAndMatchID(chosenDevice.MediaID)) devHasPartnerLicense = checkDevicePartnerLicense(chosenDevice);
                else if (DoohHelper.isValidAndMatchID(chosenDevice.GroupID)) {
                    angular.forEach(chosenDevice.GroupMediaDevices, function (grDev) {
                        if (devHasPartnerLicense) return;
                        devHasPartnerLicense = checkDevicePartnerLicense(grDev);
                    });
                }

                if (DoohHelper.isValidAndMatchID(chosenDevice.MediaID))
                    noLicenseDevices = processNoLicense(oldListIndex, chosenDevice, chosenCampaign, calendarStart, calendarEnd, devicesWithNoLicense, noLicenseDevices, devHasPartnerLicense, repeatData);
                else
                    noLicenseDevices = processGroupNoLicense(oldListIndex, chosenDevice, chosenCampaign, calendarStart, calendarEnd, devicesWithNoLicense, noLicenseDevices, devHasPartnerLicense, repeatData);
            });
            if (noLicenseDevices.length == 0)
                ScheduleHelper.flags.isLicenseLoading = false;

            PaymentHelper.setTotalSum((PaymentHelper.getTotalSum()).toFixed(2));
            
            deferred.resolve(noLicenseDevices);

            return deferred.promise;
        }

        function processNoLicense(oldListIndex, device, chosenCampaign, calendarStart, calendarEnd, prevNoLicenseDevices, noLicenseDevices, devHasPartnerLicense, repeatData) {
            var tzName = moment.tz.guess();
            if (oldListIndex == -1 || devHasPartnerLicense) {
                if (device.hasLicense != true || devHasPartnerLicense) {

                    device.licenseOption = User.hasAccess('Price')
                        ? PaymentHelper.licenseOptions().rent
                        : PaymentHelper.licenseOptions().voucher;

                    calculatePaymentPeriod(device, calendarStart, calendarEnd, repeatData.StartDate, tzName, devHasPartnerLicense);

                    noLicenseDevices.push(device);

                    if (User.hasAccess('Price')) {
                        PaymentHelper.addTotalSum((chosenCampaign.RentingPrice * device.monthsDiff));
                    }
                }
            } else {
                if (device.hasLicense != true) {
                    switch (prevNoLicenseDevices[oldListIndex].licenseOption.value) {
                        case PaymentHelper.licenseOptions().rent.value://case 'Rent':
                            calculatePaymentPeriod(device, calendarStart, calendarEnd, repeatData.StartDate, tzName, devHasPartnerLicense);
                            PaymentHelper.addTotalSum((chosenCampaign.RentingPrice * device.monthsDiff));
                            break;
                        case PaymentHelper.licenseOptions().buy.value://'Buy':
                            PaymentHelper.addTotalSum((PaymentHelper.getTotalSum() + chosenCampaign.Price));
                            break;
                        case PaymentHelper.licenseOptions().voucher.value:
                            calculatePaymentPeriod(device, calendarStart, calendarEnd, repeatData.StartDate, tzName, devHasPartnerLicense);
                            break;
                        default:
                            break;
                    }
                    noLicenseDevices.push(device);
                }
            }
            return noLicenseDevices;
        }

        function calculatePaymentPeriod(device, calendarStart, calendarEnd, repeatDataStartDate, tzName, devHasPartnerLicense) {
            PaymentHelper.calculatePaymentPeriod(device, calendarStart, calendarEnd, repeatDataStartDate, tzName, devHasPartnerLicense);
        }

        function processGroupNoLicense(oldListIndex, group, chosenCampaign, calendarStart, calendarEnd, prevNoLicenseDevices, noLicenseDevices, devHasPartnerLicense, repeatData) {
            var tzName = moment.tz.guess();
            if (oldListIndex == -1 || devHasPartnerLicense) {
                if (group.hasLicense != true || devHasPartnerLicense) {
                    group.noLicenseDevices = [];
                    group.licenseOption = User.hasAccess('Price') ?
                        PaymentHelper.licenseOptions().rent : PaymentHelper.licenseOptions().voucher;

                    angular.forEach(group.GroupMediaDevices, function (device) {
                        if (device.hasLicense != true || checkDevicePartnerLicense(device)) {
                            calculatePaymentPeriod(device, calendarStart, calendarEnd, repeatData.StartDate, tzName, checkDevicePartnerLicense(device));

                            group.noLicenseDevices.push(device);

                            if (User.hasAccess('Price')) {
                                PaymentHelper.addTotalSum((chosenCampaign.RentingPrice * device.monthsDiff))
                            }
                        }
                    });
                    var endDates = group.noLicenseDevices.map(function (device) { return device.setLicenseEnd });
                    var latest = new Date(Math.max.apply(null, endDates));
                    group.setLicenseEnd = latest;
                    var startDates = group.noLicenseDevices.map(function (device) {
                        return device.setLicenseStart
                    });
                    var earliest = new Date(Math.min.apply(null, startDates));
                    group.setLicenseStart = earliest;

                    if (group.noLicenseDevices.length > 0)
                        noLicenseDevices.push(group);
                }
            } else {
                if (group.hasLicense != true) {
                    switch (prevNoLicenseDevices[oldListIndex].licenseOption.value) {
                        case PaymentHelper.licenseOptions().rent.value://case 'Rent':
                            angular.forEach(group.GroupMediaDevices, function (device) {
                                if (device.hasLicense != true) {
                                    calculatePaymentPeriod(device, calendarStart, calendarEnd, repeatData.StartDate, tzName, devHasPartnerLicense);
                                    PaymentHelper.addTotalSum((chosenCampaign.RentingPrice * device.monthsDiff));
                                }
                            });
                            break;
                        case PaymentHelper.licenseOptions().buy.value://'Buy':
                            PaymentHelper.addTotalSum((chosenCampaign.Price * group.noLicenseDevices.length));
                            break;
                        default:
                            break;
                    }
                    noLicenseDevices.push(group);
                }

            }
            return noLicenseDevices;
        }

        function checkDevicePartnerLicense(device) {
            return (ScheduleHelper.flags.canAquireLicense
                && device.hasLicense
                && device.LicensesPeriods
                && device.LicensesPeriods.length > 0
                && device.LicensesPeriods[0][0].LicenseType != 0);
        }

        function toggleLicenseAcquire(hide, repeatData, chosenCampaign, chosenDevices) {
            var calendarStart = processCalendarStartForLicense(repeatData);
            var calendarEnd = processCalendarEndForLicense(repeatData);
            if (!hide) {
                ScheduleHelper.flags.canAquireLicense = true;
                processNoLicenseDevices(calendarStart, calendarEnd, chosenCampaign, chosenDevices, licenseData.noLicenseDevices, repeatData)
                    .then(function (noLicenseDevices) {
                        licenseData.noLicenseDevices = noLicenseDevices;
                        if (ScheduleHelper.flags.canAquireLicense)
                            loadVouchers(repeatData, ScheduleHelper.repeatPlaceHolders, chosenCampaign, noLicenseDevices, ScheduleHelper.flags.canAquireLicense);
                    });
            } else {
                ScheduleHelper.flags.canAquireLicense = false;
                if (licenseData.licensesList.length == chosenDevices.length) {
                    licenseData.noLicenseDevices = [];
                }
                else processNoLicenseDevices(calendarStart, calendarEnd, chosenCampaign, chosenDevices, licenseData.noLicenseDevices)
                    .then(function (noLicenseDevices) {
                        licenseData.noLicenseDevices = noLicenseDevices;
                        if (ScheduleHelper.flags.canAquireLicense)
                            loadVouchers(repeatData, ScheduleHelper.repeatPlaceHolders, chosenCampaign, noLicenseDevices, ScheduleHelper.flags.canAquireLicense);
                    });

                ScheduleValidationHelper.messages.errorMsgs = ScheduleValidationHelper.messages.errorMsgs
                    .filter(message => message.code !== ScheduleValidationHelper.ERROR_CODES.checkPayment);
            }
        }

        function processCalendarStartForLicense(repeatData) {

            var calendarStart = repeatData.StartDate;

            if (repeatData.IsAllDay)
                calendarStart = DoohHelper.setTimeOfDate(calendarStart, '0:0');
            else
                calendarStart = DoohHelper.setTimeOfDate(calendarStart, repeatData.StartTime);
            return calendarStart;
        }

        function processCalendarEndForLicense(repeatData) {

            var calendarEnd = repeatData.EndDate;

            if (repeatData.IsAllDay) {
                calendarEnd = DoohHelper.stringToDate(moment(calendarEnd).add(1, ScheduleHelper.TIME_UNITS.days).format(DoohHelper.dcFormat), true);
                calendarEnd = DoohHelper.setTimeOfDate(calendarEnd, '0:0');
            } else
                calendarEnd = DoohHelper.setTimeOfDate(calendarEnd, repeatData.EndTime);

            if (repeatData.IsRecurrence && repeatData.CalculatedEnd != null && repeatData.CalculatedEnd.end) {
                calendarEnd = DoohHelper.stringToDate(repeatData.CalculatedEnd.end);
                if (!repeatData.IsAllDay) {
                    calendarEnd = DoohHelper.setTimeOfDate(calendarEnd, repeatData.EndTime);
                    if (calendarEnd > DoohHelper.stringToDate(repeatData.CalculatedEnd.end))
                        calendarEnd = DoohHelper.stringToDate(DoohHelper.dateToMoment(calendarEnd).subtract(1, ScheduleHelper.TIME_UNITS.days).format(DoohHelper.dtcFormat));
                }
            }
            return calendarEnd;
        }

        function loadVouchers(repeatData, repeatPlaceHolders, chosenCampaign, noLicenseDevices, licenseAcquire) {
            PaymentHelper.loadVoucher(
                repeatData.IsRecurrence == true
                    ? ScheduleHelper.normalizeRepeatDate(repeatData.RepeatEndDate, repeatData.EndTime, repeatData.IsAllDay)
                    : ScheduleHelper.normalizeRepeatDate(repeatData.EndDate, repeatData.EndTime, repeatData.IsAllDay),
                ScheduleHelper.normalizeRepeatDate(repeatData.StartDate, repeatData.StartTime, repeatData.IsAllDay),
                false,
                repeatPlaceHolders,
                chosenCampaign.ApplicationID,
                chosenCampaign.VendorID,
                noLicenseDevices,
                repeatData.IsAllDay,
                licenseAcquire)
                .then(function () {
                    ScheduleHelper.flags.isLicenseLoading = false;
                });
        }
    }]);